import { render, staticRenderFns } from "./start_adv_temp_edit.vue?vue&type=template&id=38e86c3f"
import script from "./start_adv_temp_edit.vue?vue&type=script&lang=js"
export * from "./start_adv_temp_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports